var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1601 8.32003L9.0481 7.28003",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 10.9119L7.48804 9.87195",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.832 15.064C16.832 15.064 15.792 16.104 16.832 17.144C16.832 18.184 17.872 21.296 15.792 21.296C14.752 21.296 13.712 21.296 13.712 21.296",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.448 14.024C33.448 14.024 28.256 10.912 22.024 14.024C22.024 14.024 19.944 16.104 18.912 12.984",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.448 17.144C33.448 17.144 28.256 12.992 20.984 18.184C20.984 19.224 22.024 20.264 20.984 21.296C20.984 22.336 20.984 22.336 22.024 23.376C22.024 23.376 25.136 27.528 16.832 30.648",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.504 22.856L24.104 24.408",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6241 25.968C22.6241 25.968 22.0241 28.56 23.0641 30.64C23.0641 31.68 24.1041 32.72 23.0641 33.752",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.912 34.792C18.912 34.792 22.024 29.6 22.024 27.52",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2161 18.184C27.2161 18.184 30.3281 20.264 26.1761 24.416C27.2161 26.496 29.2881 31.688 22.0241 37.912C20.9841 38.952 18.9121 39.992 15.7921 36.872C12.6721 33.752 3.33608 27.528 8.52808 21.296",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52805 15.064C8.52805 15.064 4.37605 19.216 7.48805 23.368",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.64 19.216C11.64 19.216 10.6 10.912 15.792 8.83198C15.792 8.83198 18.904 7.79198 17.872 2.59998",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.064 10.912C23.064 10.912 20.984 6.76001 15.792 8.83201C17.872 7.79201 23.064 8.83201 25.136 3.64001",
    stroke: "#A977F9",
    strokeMiterlimit: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHealth);
export default __webpack_public_path__ + "static/media/HeartHealth.ca09056f33462b3063d4ae0abb02d475.svg";
export { ForwardRef as ReactComponent };